import React from 'react';
import { Chip } from '@mui/material';
import {
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  PlayArrow as PlayArrowIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { jobStatusChipStyles } from './styles';

interface JobStatusChipProps {
  status: string;
}

export const JobStatusChip: React.FC<JobStatusChipProps> = ({ status }) => {
  const { t } = useTranslation();

  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'pending':
        return {
          label: t('hotelContent.jobs.modal.status.pending'),
          color: 'warning' as const,
          icon: <ScheduleIcon fontSize='small' />,
        };
      case 'processing':
        return {
          label: t('hotelContent.jobs.modal.status.processing'),
          color: 'info' as const,
          icon: <PlayArrowIcon fontSize='small' />,
        };
      case 'completed':
        return {
          label: t('hotelContent.jobs.modal.status.completed'),
          color: 'success' as const,
          icon: <CheckCircleIcon fontSize='small' />,
        };
      case 'failed':
        return {
          label: t('hotelContent.jobs.modal.status.failed'),
          color: 'error' as const,
          icon: <ErrorIcon fontSize='small' />,
        };
      default:
        return {
          label: status,
          color: 'default' as const,
          icon: <ScheduleIcon fontSize='small' />,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      icon={config.icon}
      sx={jobStatusChipStyles}
    />
  );
};
